const C = {
  name: "Heart",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 9.33333C2 5.82715 4.88046 3 8.4 3C9.7051 3 10.9515 3.38761 12 4.1014C13.0485 3.38761 14.2949 3 15.6 3C19.1195 3 22 5.82715 22 9.33333C22 12.6798 19.6529 15.5266 17.5185 17.4515C15.3492 19.4078 13.144 20.6398 12.9232 20.7605C12.6308 20.9223 12.3206 21 12 21C11.6794 21 11.3692 20.9223 11.0768 20.7605C10.856 20.6398 8.65077 19.4078 6.48154 17.4515C4.34708 15.5266 2 12.6798 2 9.33333ZM8.4 5C5.96154 5 4 6.95507 4 9.33333C4 11.7736 5.76142 14.1089 7.82096 15.9663C9.72837 17.6864 11.6798 18.8069 12 18.9856C12.3202 18.8069 14.2716 17.6864 16.179 15.9663C18.2386 14.1089 20 11.7736 20 9.33333C20 6.95507 18.0385 5 15.6 5C14.4949 5 13.4641 5.3989 12.6677 6.11328L12 6.71228L11.3323 6.11328C10.5359 5.3989 9.50508 5 8.4 5Z" fill="currentColor"/>
    </g>
    `
};
export {
  C as Heart
};
